export const tableFileTypes = [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

/** 判断click事件是否只是点击, 不包括拖动 */
export const isOnlyClick = (() => {
    const mouseDownPoint: {
        clientX: number | null;
        clientY: number | null;
    } = {
        clientX: null,
        clientY: null,
    };
    document.body?.addEventListener(
        'mousedown',
        (e) => {
            mouseDownPoint.clientX = e.clientX;
            mouseDownPoint.clientY = e.clientY;
        },
        false,
    );

    const isOnlyClick = (clickEndPoint: { clientX: number; clientY: number }) => {
        const { clientX, clientY } = clickEndPoint;
        const { clientX: mouseDownClientX, clientY: mouseDownClientY } = mouseDownPoint;
        const isOnlyClick = clientX === mouseDownClientX && clientY === mouseDownClientY;
        if (!isOnlyClick && mouseDownClientX !== null && mouseDownClientY !== null) {
            console.log('===不是点击操作, 还移动了一点点', {
                deltaX: clientX - mouseDownClientX,
                deltaY: clientY - mouseDownClientY,
            });
        }
        return isOnlyClick;
    };
    return isOnlyClick;
})();
